import React from "react";
import firebase from "../firebase/firebase";

export const createAccount = (email, password, callback) => {
  const fs = firebase;

  fs.auth()
    .createUserWithEmailAndPassword(email.toLowerCase(), password)
    .then((user) => {
      callback({ data: user });
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      callback({ error: error });
    });
};

export const signInWithEmail = (email, password, callback) => {
  const fs = firebase;

  fs.auth()
    .signInWithEmailAndPassword(email.toLowerCase(), password)
    .then((user) => {
      callback({ login: true });
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      callback({ error: error });
    });
};

export const createUser = (email, addNewUser, callback) => {
  const fs = firebase.firestore();
  const sss = fs
    .collection("users")
    .doc(email.toLowerCase())
    .set(addNewUser)
    .then(() => {
      callback({ login: true });
    })
    .catch((error) => {
      callback({
        error: true,
        errorMsg: "unable to create a new account, please try again",
      });
    });
};

export const getUser = (email, callback) => {
  const fs = firebase.firestore();
  const sss = fs
    .collection("users")
    .doc(email.toLowerCase())
    .get()
    .then((doc) => {
      callback({ userInfo: doc.data() });
    })
    .catch((error) => {
      callback({
        error: true,
        errorMsg: "unable to find user, please try again",
      });
    });
};

export const forgotPassword = (email, callback) => {
  var auth = firebase.auth();

  auth
    .sendPasswordResetEmail(email.toLowerCase())
    .then(() => {
      callback({ done: "sent" });
    })
    .catch((error) => {
      callback({
        error: true,
        errorMsg: "unable to send email, please try again",
      });
    });
};
